import { call, put, takeLatest } from 'redux-saga/effects';
import * as apollo from 'apollo/notes.query';
import * as types from './types';

function* getNoteTemplateFolders() {
  try {
    const response = yield call(apollo.fetchNoteTemplateFolders);
    yield put({ type: types.GET_NOTE_TEMPLATE_FOLDERS_SUCCESS, payload: response?.noteTemplateFolderList });
  } catch (err) {
    yield put({ type: types.GET_NOTE_TEMPLATE_FOLDERS_FAIL });
  }
}

function* createNoteTemplateFolder(action) {
  const { payload } = action || {};
  try {
    const response = yield call(apollo.createNoteTemplateFolder, payload);
    yield put({ type: types.CREATE_NOTE_TEMPLATE_FOLDER_SUCCESS, payload: response?.createNoteTemplateFolder });
    yield put({ type: types.GET_NOTE_TEMPLATE_FOLDERS });
  } catch (err) {
    yield put({ type: types.CREATE_NOTE_TEMPLATE_FOLDER_FAIL });
  }
}

function* updateNoteTemplateFolder(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.updateNoteTemplateFolder, payload);
    yield put({ type: types.UPDATE_NOTE_TEMPLATE_FOLDER_SUCCESS, payload: response });
  } catch (err) {
    yield put({ type: types.UPDATE_NOTE_TEMPLATE_FOLDER_FAIL });
  }
}

function* deleteNoteTemplateFolder(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.deleteNoteTemplateFolder, payload);
    yield put({ type: types.DELETE_NOTE_TEMPLATE_FOLDER_SUCCESS, payload: response });
    yield put({ type: types.GET_NOTE_TEMPLATE_FOLDERS });
  } catch (err) {
    yield put({ type: types.DELETE_NOTE_TEMPLATE_FOLDER_FAIL });
  }
}

function* reorderNoteTemplateFolders(action) {
  const { payload } = action || {};

  try {
    const response = yield call(apollo.reorderNoteTemplateFolders, payload);
    yield put({ type: types.REORDER_NOTE_TEMPLATE_FOLDERS_SUCCESS, payload: response });
    yield put({ type: types.GET_NOTE_TEMPLATE_FOLDERS });
  } catch (err) {
    yield put({ type: types.REORDER_NOTE_TEMPLATE_FOLDERS_FAIL });
  }
}

export default function* watchList() {
  yield takeLatest(types.GET_NOTE_TEMPLATE_FOLDERS, getNoteTemplateFolders);
  yield takeLatest(types.CREATE_NOTE_TEMPLATE_FOLDER, createNoteTemplateFolder);
  yield takeLatest(types.UPDATE_NOTE_TEMPLATE_FOLDER, updateNoteTemplateFolder);
  yield takeLatest(types.DELETE_NOTE_TEMPLATE_FOLDER, deleteNoteTemplateFolder);
  yield takeLatest(types.REORDER_NOTE_TEMPLATE_FOLDERS, reorderNoteTemplateFolders);
}
